import styled from 'styled-components';

export const StyledUserDetails = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background.main};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  padding: 4.6rem;
  border-radius: ${({ theme }) => theme.radius.small};
`;

export const StyledTitle = styled.p`
  font-size: 2.4rem;
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 1.6rem;
`;

export const StyledRow = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0;
  padding-bottom: 1.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 3.2rem;
  }
`;
